import { observer } from "mobx-react-lite";
import React from "react";
import styled from "styled-components";
import { gameStats } from "../../integration/GameStatsIntegration";
import { localSettingsStore } from "../../stores/LocalSettingsStore";
const Container = styled.div.withConfig({
  displayName: "GameStatsContainer__Container",
  componentId: "sc-1m8z0i7-0"
})(["position:absolute;top:110px;left:30px;pointer-events:none;div{position:relative !important;}"]);
export const GameStatsContainer = observer(() => {
  if (!localSettingsStore.showPerformanceInfo) return null;
  return /*#__PURE__*/React.createElement(Container, {
    ref: ref => {
      if (ref) {
        gameStats.addGameStatsToDom(ref);
      } else {
        gameStats.removeGameStatsFromDom();
      }
    }
  });
});